import storage from './internal/configStorage';
const store = storage({});
export default store;

export function dispatchAction(action) {
	const s = store.get();
	if (s && typeof s.dispatch === 'function') {
		s.dispatch(action);
	}
}


// WEBPACK FOOTER //
// ./node_modules/linksoft/src/store.js